import React from 'react';
import { BaseText as BaseTextNew } from './BaseText';
import { convertOldBaseTextProps } from './converter.old';
import type { OldBaseTextProps } from './converter.old';
import type { BaseTextElement } from './BaseText';

export type BaseTextProps = OldBaseTextProps;
export type BaseTextComponentProps = BaseTextProps & JSX.IntrinsicElements[BaseTextElement];

export const BaseText: React.FC<BaseTextComponentProps> = (props) => (
  <BaseTextNew {...convertOldBaseTextProps(props)} />
);
